function sourceRoute(name, id) {
  if (!id) return null;

  return { name, params: { id } };
}

export function edoSourceOrderRoute(orderId) {
  return sourceRoute("OrderDetails", orderId);
}

export function edoSourceTripRoute(tripId) {
  return sourceRoute("TripDetails", tripId);
}
